import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../media';

export const StyledDiv = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	max-width: 776px;
	padding: 24px;
	margin-top: 40px;
	column-gap: 20px;
	background-color: var(--background-secondary);
	border-radius: 8px;

	${media.mobile} {
		flex-direction: column;
		align-items: start;
		justify-content: initial;
		padding: 16px;
		row-gap: 16px;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: 16px;

	${media.mobile} {
		flex-direction: column;
		align-items: start;
		row-gap: 16px;
	}
`;

export const buttonStyles = css`
	${media.mobile} {
		width: 100%;
	}
`;

export const selectedStoreDivStyles = css`
	${media.mobile} {
		padding: 24px;
	}
`;

export const StoreName = styled.a`
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.05px;
	text-decoration: none;
	color: var(--text-primary);

	@media (hover) {
		&:hover {
			color: var(--success-dark);
		}
	}
`;

export const infoBarStyles = css`
	width: 100%;
	max-width: 776px;
`;

export const StoreInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 8px;
`;
